(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const filterToggle = document.querySelector('[data-filter-toggle]');
    const filterContainer = document.getElementById('CollectionFilters');
    const sortSelect = document.querySelector('[data-sort-by]');
    const filtersForm = document.querySelector('.collection-page__filters-form');

    // Restore filters open/closed state from sessionStorage
    if (filterContainer) {
      const isDrawerOpen = sessionStorage.getItem('filters-drawer-open');
      if (isDrawerOpen === 'true') {
        filterContainer.classList.add('is-open');
        filterContainer.setAttribute('aria-hidden', 'false');
      } else if (isDrawerOpen === 'false') {
        filterContainer.classList.remove('is-open');
        filterContainer.setAttribute('aria-hidden', 'true');
      }
    }

    // Restore checkbox states from URL parameters on page load
    const urlParams = new URLSearchParams(window.location.search);
    const checkboxes = document.querySelectorAll('.filter-group__checkbox');
    checkboxes.forEach(checkbox => {
      const name = checkbox.getAttribute('name');
      const value = checkbox.getAttribute('value');
      if (urlParams.has(name)) {
        const activeValues = urlParams.getAll(name);
        if (activeValues.includes(value)) {
          checkbox.checked = true;
        }
      }
    });

    if (filterToggle && filterContainer) {
      filterToggle.addEventListener('click', () => {
        const isOpen = filterContainer.classList.contains('is-open');
        if (isOpen) {
          filterContainer.classList.remove('is-open');
          filterContainer.setAttribute('aria-hidden', 'true');
          sessionStorage.setItem('filters-drawer-open', 'false');
        } else {
          filterContainer.classList.add('is-open');
          filterContainer.setAttribute('aria-hidden', 'false');
          sessionStorage.setItem('filters-drawer-open', 'true');
        }
      });

      // Close filters menu when clicking outside
      document.addEventListener('click', (e) => {
        const isOpen = filterContainer.classList.contains('is-open');
        if (isOpen && !filterContainer.contains(e.target) && !filterToggle.contains(e.target)) {
          filterContainer.classList.remove('is-open');
          filterContainer.setAttribute('aria-hidden', 'true');
          sessionStorage.setItem('filters-drawer-open', 'false');
        }
      });
    }

    // Automatically submit form when a filter checkbox is changed
    if (filtersForm) {
      filtersForm.addEventListener('change', () => {
        filtersForm.submit();
      });
    }

    // Handle Sort Changes
    if (sortSelect) {
      sortSelect.addEventListener('change', (e) => {
        const value = e.target.value;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.href;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  window.initCarousel = (sectionId) => {
    const container = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!container) return;

    const track = container.querySelector('[data-carousel-track]');
    if (!track) return;

    // Clean up any existing clones from previous versions
    track.querySelectorAll('.is-clone').forEach(el => el.remove());
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collection-carousel').forEach(carousel => {
      window.initCarousel(carousel.dataset.sectionId);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('collection-carousel')) {
      initCarousel(event.detail.sectionId);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    const toggle = document.querySelector('.header__mobile-toggle');
    const menu = document.querySelector('.mobile-menu');

    if (!header || !toggle || !menu) return;

    // Slide-down Search Bar Logic
    const searchTriggers = document.querySelectorAll('[data-search-trigger]');
    const searchBar = document.getElementById('HeaderSearch');
    const searchInput = searchBar ? searchBar.querySelector('[data-search-input]') : null;
    const searchClose = searchBar ? searchBar.querySelector('[data-close-search]') : null;

    const handleScroll = () => {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      const heroSection = document.querySelector('.hero-dual');
      if (heroSection) {
        const headerHeight = header.offsetHeight;
        const triggerPoint = heroSection.offsetHeight - headerHeight;
        if (window.scrollY >= triggerPoint) {
          header.classList.add('is-past-hero');
        } else {
          header.classList.remove('is-past-hero');
        }
      } else {
        header.classList.add('is-past-hero');
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    toggle.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';

      // Close search if open when mobile menu toggled
      if (isOpen && searchBar && searchBar.classList.contains('is-open')) {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
        header.classList.remove('search-is-open');
      }
    });
    
    // Close menu on link click
    menu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });

    // Mobile dropdown toggle
    const trigger = menu.querySelector('.mobile-menu__link--trigger');
    const mobileDropdown = menu.querySelector('.mobile-menu__dropdown');
    if (trigger && mobileDropdown) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = mobileDropdown.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen);
      });
    }

    if (searchBar && searchInput) {
      searchTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Close mobile menu if open
          if (menu.classList.contains('is-open')) {
            menu.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
          }
          
          const isOpen = searchBar.classList.toggle('is-open');
          searchBar.setAttribute('aria-hidden', !isOpen);
          header.classList.toggle('search-is-open', isOpen);
          if (isOpen) {
            setTimeout(() => searchInput.focus(), 100);
          }
        });
      });

      if (searchClose) {
        searchClose.addEventListener('click', () => {
          searchBar.classList.remove('is-open');
          searchBar.setAttribute('aria-hidden', 'true');
          header.classList.remove('search-is-open');
        });
      }

      // Close search if clicking SHOP while search is open
      const shopLink = document.querySelector('.header__menu-item--has-dropdown > .header__menu-link');
      if (shopLink) {
        shopLink.addEventListener('click', (e) => {
          if (searchBar.classList.contains('is-open')) {
            e.preventDefault();
            searchBar.classList.remove('is-open');
            searchBar.setAttribute('aria-hidden', 'true');
            header.classList.remove('search-is-open');
          }
        });
      }

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
          searchBar.classList.remove('is-open');
          searchBar.setAttribute('aria-hidden', 'true');
          header.classList.remove('search-is-open');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductForm {
    constructor(container) {
      this.container = container;
      this.priceElement = container.querySelector('.product-main__price');
      this.addButton = container.querySelector('.product-main__add-to-cart-button');
      this.idInput = container.querySelector('input[name="id"]');
      this.statusTagsContainer = container.querySelector('.product-main__status-tags');
      this.productData = JSON.parse(container.querySelector('[data-product-json]').textContent);
      
      this.lightbox = document.getElementById('product-lightbox');
      this.lightboxImage = this.lightbox.querySelector('.product-lightbox__image');
      this.lightboxClose = this.lightbox.querySelector('.product-lightbox__close');

      this.init();
    }

    init() {
      this.container.addEventListener('change', (e) => {
        if (e.target.matches('.product-main__radio-input')) {
          this.updateVariant();
        }
      });

      this.container.querySelectorAll('[data-zoomable]').forEach(item => {
        item.addEventListener('click', () => {
          const img = item.querySelector('img');
          if (img) this.openLightbox(img.src);
        });
      });

      this.lightboxClose.addEventListener('click', () => this.closeLightbox());
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this.closeLightbox();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeLightbox();
      });
    }

    openLightbox(src) {
      this.lightboxImage.src = src;
      this.lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
      this.lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    updateVariant() {
      const selectedOptions = Array.from(this.container.querySelectorAll('.product-main__radio-input:checked')).map(input => input.value);
      const variant = this.productData.variants.find(v => {
        return v.options.every((opt, index) => opt === selectedOptions[index]);
      });

      if (variant) {
        this.idInput.value = variant.id;
        this.priceElement.textContent = Shopify.formatMoney(variant.price);
        
        // Update Status Tags and Button
        let statusHtml = '';
        if (variant.available) {
          this.addButton.disabled = false;
          this.addButton.classList.remove('product-main__add-to-cart-button--preorder');
          
          if (this.productData.tags.includes('Pre-order')) {
            statusHtml = '<span class="product-tag product-tag--preorder">PRE-ORDER</span>';
            this.addButton.textContent = 'PRE-ORDER NOW';
            this.addButton.classList.add('product-main__add-to-cart-button--preorder');
          } else {
            this.addButton.textContent = 'ADD TO BAG';
            if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
              statusHtml = `<span class="product-tag product-tag--low-stock">ONLY ${variant.inventory_quantity} LEFT</span>`;
            }
          }
        } else {
          this.addButton.disabled = true;
          this.addButton.textContent = 'SOLD OUT';
          statusHtml = '<span class="product-tag product-tag--soldout">SOLD OUT</span>';
        }

        this.statusTagsContainer.innerHTML = statusHtml;

        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-section]');
    containers.forEach(c => new ProductForm(c));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var dialog = document.getElementById('password-dialog');
    var openBtn = document.getElementById('open-password-dialog');
    var closeBtn = document.getElementById('close-password-dialog');

    if (!dialog) return;

    if (openBtn) {
      openBtn.addEventListener('click', function() {
        dialog.showModal();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        dialog.close();
      });
    }

    // Close on backdrop click
    dialog.addEventListener('click', function(event) {
      var rect = dialog.getBoundingClientRect();
      var isInDialog = (
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width
      );
      if (!isInDialog) {
        dialog.close();
      }
    });

    // Auto-open if redirected with storefront password error
    if (dialog.getAttribute('data-has-errors') === 'true') {
      dialog.showModal();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const initRelatedProducts = () => {
    const productRecommendationsSection = document.querySelector('.related-products');
    if (!productRecommendationsSection) return;

    const observer = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.related-products');

          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            // Initialize carousel JS for the new content
            if (window.initCarousel) {
              window.initCarousel(productRecommendationsSection.dataset.sectionId);
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    }, {rootMargin: '0px 0px 400px 0px'});

    observer.observe(productRecommendationsSection);
  };

  document.addEventListener('DOMContentLoaded', initRelatedProducts);
  document.addEventListener('shopify:section:load', initRelatedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
  class WishlistPage {
    constructor() {
      this.grid = document.getElementById('WishlistGrid');
      this.emptyState = document.getElementById('WishlistEmpty');
      this.init();
    }

    init() {
      this.render();
      document.addEventListener('wishlist:updated', () => this.render());
    }

    getWishlist() {
      return JSON.parse(localStorage.getItem('llur_wishlist') || '[]');
    }

    async render() {
      const items = this.getWishlist();
      
      if (items.length === 0) {
        this.grid.style.display = 'none';
        this.emptyState.style.display = 'block';
        return;
      }

      this.grid.style.display = 'grid';
      this.emptyState.style.display = 'none';
      this.grid.innerHTML = '<p style="text-align:center; grid-column: 1/-1; opacity: 0.5;">LOADING YOUR PIECES...</p>';

      const productPromises = items.map(handle => fetch(`/products/${handle}.js`).then(res => res.json()));
      
      try {
        const products = await Promise.all(productPromises);
        this.grid.innerHTML = products.map(product => this.renderProductCard(product)).join('');
        if (window.Wishlist && typeof window.Wishlist.updateButtons === 'function') {
          window.Wishlist.updateButtons();
        }
      } catch (e) {
        console.error('Error loading wishlist products:', e);
        this.grid.innerHTML = '<p style="text-align:center; grid-column: 1/-1;">COULD NOT LOAD WISHLIST. PLEASE TRY AGAIN LATER.</p>';
      }
    }

    renderProductCard(product) {
      // Formats price using Shopify filter logic (simplified)
      const price = Shopify.formatMoney(product.price);

      return `
        <div class="wishlist-item" data-handle="${product.handle}">
          <a href="${product.url}" class="product-card">
            <div class="product-card__image-wrapper">
              <img src="${product.featured_image}" alt="${product.title}" class="product-card__image" loading="lazy">
              <button type="button" class="product-card__wishlist-btn" data-wishlist-card-heart="${product.handle}" onclick="event.preventDefault(); window.Wishlist.toggle('${product.handle}')" aria-label="Add to wishlist">
                <svg class="icon icon-heart" viewBox="0 0 24 24" width="20" height="20" fill="none">
                  <path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
            </div>
            <div class="product-card__info">
              <div class="product-card__top">
                <span class="product-card__vendor">${product.vendor.toUpperCase()}</span>
                <button class="wishlist-remove" onclick="event.preventDefault(); window.Wishlist.toggle('${product.handle}')">REMOVE</button>
              </div>
              <div class="product-card__details">
                <h3 class="product-card__title">${product.title.toUpperCase()}</h3>
                <span class="product-card__price">${price}</span>
              </div>
            </div>
          </a>
        </div>
      `;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('WishlistGrid')) {
      new WishlistPage();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
